import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as BackArrowIcon } from '../../../../../assets/images/backarrow.svg';
import { ReactComponent as CrossIcon } from '../../../../../assets/images/CrossIcon.svg';
import { ReactComponent as DocumentIcon } from '../../../../../assets/images/document.svg';
import CustomTextField from '../../../../../components/shared/CustomTextField/CustomTextField';

import MappingSelect from './MappingSelect/MappingSelect';

import styles from './Mapping.module.scss';

const Mapping = ({ file, importedHeaders, customFields, setCustomFields, fieldMapping, setFieldMapping }) => {
  const { t } = useTranslation('common');
  const getDropdownValue = useCallback(
    (index) => {
      const mappedValue = fieldMapping.find(({ id }) => id === index);
      return mappedValue?.value ? mappedValue : null;
    },
    [fieldMapping]
  );

  const handleFieldValueChange = useCallback((selectedOption, index) => {
    setFieldMapping((prevMapping) =>
      prevMapping.map((field) => {
        if (field.id === index) {
          return { ...field, label: selectedOption?.label, value: selectedOption?.value };
        }
        return field;
      })
    );
  }, []);

  const getTextFieldValue = useCallback(
    (index) => fieldMapping.find(({ id }) => id === index).customValue || '',
    [fieldMapping]
  );

  const handleCustomFieldValue = useCallback((val, index) => {
    setFieldMapping((prevMapping) =>
      prevMapping.map((field) => {
        if (field.id === index) {
          return { ...field, customValue: val };
        }
        return field;
      })
    );
  }, []);

  const handleChangeCustomField = useCallback(
    (index, newState) => {
      handleCustomFieldValue(index, '');
      setCustomFields((prevState) => prevState.map((field, i) => (i === index ? newState : field)));
    },
    [handleCustomFieldValue]
  );

  const selectedOptions = useMemo(
    () => fieldMapping.map(({ value }) => value).filter((value) => value),
    [fieldMapping]
  );

  return (
    <div>
      <p className={styles.heading}>{t('csvImport.contactFieldMapping')}</p>
      <div className={styles.fileCont}>
        <DocumentIcon />
        <p className={styles.fileName}>{file.name}</p>
      </div>
      <div className={styles.mappingTool}>
        <div className={styles.elCont}>
          <div className={styles.importHeading}>{t('csvImport.importValue')}</div>
          <div className={styles.arrowCont} />
          <div className={styles.boonHeading}>{t('csvImport.boonValue')}</div>
          <div className={styles.boonMobileHeading}>{t('csvImport.matchBoonValue')}</div>
        </div>
        {importedHeaders.map((importedHeader, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className={styles.elCont} key={importedHeader + index}>
            <div className={styles.importedVal}>{importedHeader}</div>
            <div className={styles.arrowCont}>
              <BackArrowIcon />
            </div>
            <div className={styles.selectCont}>
              {customFields[index] ? (
                <div className={styles.inputCont}>
                  <CustomTextField
                    label={t('csvImport.customField')}
                    defaultValue={getTextFieldValue(index)}
                    onBlur={(e) => handleCustomFieldValue(e.target.value, index)}
                  />
                  <CrossIcon onClick={() => handleChangeCustomField(index, false)} />
                </div>
              ) : (
                <MappingSelect
                  value={getDropdownValue(index)}
                  selectedOptions={selectedOptions}
                  onChange={(v) => handleFieldValueChange(v, index)}
                  handleAddCustomField={() => handleChangeCustomField(index, true)}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Mapping;
